import { useEffect } from "react";
import WebSocketManager from "./client.js";

export function useMenuUpdates({ clientCode, onMenuUpdated }) {
    useEffect(() => {
        if (!clientCode) return;

        const topic = `/topic/clients/${clientCode}/menu`;

        const callback = (message) => {
            if (message === "UPDATED" && onMenuUpdated) onMenuUpdated();
        };

        WebSocketManager.subscribe(topic, callback);

        return () => {
            WebSocketManager.unsubscribe(topic);
        };
    }, [clientCode, onMenuUpdated]);
}
